import './style.scss';

export const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found-title">Theres nothing here: 404!</div>
    </div>
  );
};
